const getters = {
  uk (state) {
    return state.geoLookup.countries.find(country => country.alpha3 === 'GBR')
  }
}

export default getters
